module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"title":"Выгрузка из ЭТРАН АГХК","upload":"Загрузить","ds-manager:creation:from-file:upload-tip1":"Перетащите файл сюда или ","ds-manager:creation:from-file:upload-tip2":"кликните для загрузки","ds-manager:creation:from-file:uploaded-title":"Запрос отправлен","ds-manager:creation:from-file:uploaded-text":"Запрос на выгрузку из ЭТРАН отправлен. Номер задачи - "}}')
  delete Component.options._Ctor
}
